const isGifImageUrl = (url: string): boolean => {
    return url.toLowerCase().endsWith('.gif');
};

export { isGifImageUrl };
